export const knowledge_cn = {
  // 通用
  view_more: '查看更多',
  join_now_title: '即刻链接全球货代',
  join_now_desc: '全球10,000+货代企业的选择',
  join_now_button: '加入会员',
  back_to_list: '返回列表',
  last: '上一条',
  next: '下一条',

  // 新闻
  banner_news: '新闻',
  banner_news_desc: '获得行业及会员的所有最新动态新闻',
  member_news: '会员新闻',
  logistics_news: '行业新闻',
  freight_knowledge: '货运知识',
  freight_area: '货运地区',
  freight_experience: '货运经验',
  freight_solutions: '货运解决方案',
  freight_policy: '货运政策',
  jctrans_news: 'JCtrans新闻',
  source: '来源',

  // 访谈
  banner_logitalks: '高端访谈',
  banner_logitalks_desc: '倾听会员的声音和故事',
  more_logitalks: '更多会员访谈',

  // 成功故事
  banner_success_story: '成功故事',
  banner_success_story_desc: '倾听会员的声音和故事',
  more_success_story: '更多成功故事',
  district: '区域',
  district_placeholder: '选择区域',
  business: '业务',
  business_placeholder: '选择业务',
  search: '搜索',
  read: '阅读',
  like: '点赞',
}

export const knowledge_en = {
  // 通用
  view_more: 'View More',
  join_now_title: 'Apply for JCtrans membership',
  join_now_desc: 'Choice of 10,000+ freight forwarders around the world',
  join_now_button: 'Become a Member',
  back_to_list: 'Back to list',
  last: 'Last',
  next: 'Next',

  // 新闻
  banner_news: 'News',
  banner_news_desc: 'Get all the latest news from Logistics and JC members',
  member_news: 'Member News',
  logistics_news: 'Logistics News',
  freight_knowledge: 'Freight Knowledge',
  freight_area: 'Freight Area',
  freight_experience: 'Freight Experience',
  freight_solutions: 'Freight Solutions',
  freight_policy: 'Freight Policy',
  jctrans_news: 'JCtrans News',
  source: 'Source',

  // 访谈
  banner_logitalks: 'Logi-Talks',
  banner_logitalks_desc: 'Listen to the voices and stories of JCtrans members',
  more_logitalks: 'More Voice Of Members',

  // 成功故事
  banner_success_story: 'Success Stories',
  banner_success_story_desc:
    'Listen to the voices and stories of JCtrans members',
  more_success_story: 'More Success Stories',
  district: 'District',
  district_placeholder: 'Select District',
  business: 'Business',
  business_placeholder: 'Select Business',
  search: 'Search',
  read: 'Read',
  like: 'Like',
}
